import { Col, Row } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineBadge } from "react-icons/md";
import Button from "shared/components/Button";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import Label from "shared/components/Label";
import { NAME_SPACES } from "shared/locales/constants";

const Id = ({
  values,
  onFileRemove,
  setFieldValue,
  subscription,
  setPercent,
  disabled,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const TRANSLATION = t("SUBSCRIPTION_AMELLIS.PROOF", {
    returnObjects: true,
  });
  const BLOCK = get(TRANSLATION, "ID");
  return (
    <div className="subscription-form--wrapper">
      <Form type="vertical" title={BLOCK.TITLE} subtitle={BLOCK.SUBTITLE}>
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <div className="subscription-form--group-label">
              <Label
                label={BLOCK.FORM.ADHERENT}
                icon={<MdOutlineBadge size={16} />}
                required
              />
            </div>
          </Col>
          <Col lg={24} xs={24}>
            <div className="subscription-form--custom-upload">
              <Input
                type="file"
                variant="uploader"
                validTypes={TRANSLATION.ALLOWED_FILES_TYPE}
                onUpload={(fileList) => {
                  setFieldValue("proof.cin", fileList);
                  setPercent({
                    ...values,
                    proof: { ...values.proof, cin: fileList },
                  });
                }}
                onFileRemove={onFileRemove}
                fileList={get(values, "proof.cin", [])}
              >
                <Row align="center">
                  <Button type="primary--link">
                    {TRANSLATION.ACTIONS.ADD}
                  </Button>
                </Row>
              </Input>
            </div>
          </Col>
        </Row>
        {!get(subscription, "payment.payer.owner.isAdherent") && (
          <Row>
            <Col lg={24} xs={24}>
              <div className="subscription-form--group-label">
                <Label
                  label={BLOCK.FORM.PAYER}
                  icon={<MdOutlineBadge size={16} />}
                  required
                />
              </div>
            </Col>
            <Col lg={24} xs={24}>
              <div className="subscription-form--custom-upload">
                <Input
                  type="file"
                  variant="uploader"
                  validTypes={TRANSLATION.ALLOWED_FILES_TYPE}
                  onUpload={(fileList) => {
                    setFieldValue("proof.payerCin", fileList);
                    setPercent({
                      ...values,
                      proof: { ...values.proof, payerCin: fileList },
                    });
                  }}
                  onFileRemove={onFileRemove}
                  fileList={get(values, "proof.payerCin", [])}
                >
                  <Row align="center">
                    <Button type="primary--link">
                      {TRANSLATION.ACTIONS.ADD}
                    </Button>
                  </Row>
                </Input>
              </div>
            </Col>
          </Row>
        )}
      </Form>
    </div>
  );
};

export default Id;
